// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"ModeloGpsDetalle_spinnerContainer__P2QXl"};